<template>
  <div class="home">
     <van-nav-bar
      :title="$t('kmewm')"
    />
    <div v-if="!number">
        <van-field
          v-model="name"
          name="手机号码"
          label="手机号码"
          placeholder="手机号码"
          :rules="[{ required: true, message: '请填写手机号码' }]"
        />
        <div style="margin: 16px;" >
          <van-button round block type="info" @click="submits" >{{ this.$t('login') }}</van-button>
        </div>
    </div>

    <div class="qrcode" v-else>
      <vue-qr 
        :size="220"
        :margin="10"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
        
      />
    </div>

    <router-link to='/about'>
      <div class="buts">
        <img  src="@/images/icon_API_HL.png" alt="">
        <span>{{ this.$t('my') }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import CRC from "@/crc16xm/crc16array.js"
import AESHQT from "@/aeshqt/aes.js" 
// var  Base64 = require('js-base64').Base64;
import {base64ToString,CharToHex} from '@/utils/index'
var flow_no = 0;
export default {
  name: 'Home',
  components: {
    VueQr
  },
  data(){
    return{
      logoSrc: '',
      appSrc: '',
      listdata:[],
      name: '',
      password: '',
      timeout:1,
      datauser:[],
      number:JSON.parse(window.localStorage.getItem('datauser')),
      clearTimeSet:''
    }
  },
  mounted(){
    this.handeldow()
    // this.qrCodeCreate()
   
  },
  methods:{
   
  
    submits() {
      
    },
    handeldow(){
      // this.qrCodeCreate()
      this.clearTimeSet=setInterval( () =>{
          this.qrCodeCreate()
      }, 300);
    },

    


    qrCodeCreate(){
      let base64encrypt = base64ToString(this.number.encrypt)
      console.log(`马工获取的encrypt`,this.number.encrypt)
      let encrypt = CharToHex(base64encrypt)

      let u8_src = encrypt.split(',').join('')

      console.log(`马工获取解码后`,u8_src)

      //流水号 随机数(1000--2000)
      var random_number = 1000 + (flow_no++)%1000; //Math.floor(Math.random() * 1000 + 1000);
      // random_number = 1500;
      random_number = parseInt(random_number).toString(16).toUpperCase();
      random_number = this.checkHexZero(random_number);
      // random_number = 1500;

      console.log(`随机数`,random_number)

     var utc_number = new Date().getTime() / 1000;
      // console.log("时间："+utc_number);
      // utc_number = 1627625901;
      utc_number = parseInt(utc_number).toString(16).toUpperCase();
      utc_number = this.checkHexZero(utc_number);
      // utc_number = 1627625901;
      console.log("16进制时间戳: "+utc_number);

      var crc_source = u8_src + random_number + utc_number;
      // var crc_source =  random_number + utc_number;
      console.log("手机号+随机数+时间戳： "+crc_source);
      var len = crc_source.length / 2;
      var arr = new Uint8Array(len);
      var i;
      for(i=0;i<len;i++){
        arr[i] = parseInt(crc_source.substr(i*2, 2), 16);
      }
      var crc_result = CRC.CRC16func(arr)
      console.log("校验码: "+crc_result);



      var source = u8_src + random_number + utc_number + crc_result ;
      // var source = random_number + utc_number + crc_result ;

      console.log(`总字节`,source);

      var source_bytes = new Uint8Array(16);

      
      for(let i=0;i<16;i++){
        source_bytes[i] = parseInt(source.substr(i * 2,2),16);
      }

      console.log(`555`,source_bytes)

      let key = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1];
      let aes_res = AESHQT.encrypt(source_bytes,key);
      console.log(`AES加密后`,aes_res);

       let aes_bytes = new Uint8Array(aes_res.length/2);
      for (let i = 0; i < aes_res.length/2; i++) {
        aes_bytes[i] = parseInt(aes_res.substr(i * 2, 2), 16);
      }
      console.log(`44`,aes_bytes);  
    
    let strDtae =  new Buffer(new Uint8Array(aes_bytes));

     let base64_str = strDtae.toString('base64')
    console.log(`最后base64加密`,base64_str)
      var aes_result ='S'+ base64_str;
      console.log(`最终结果`,aes_result)
      this.appSrc = aes_result
    },

    checkHexZero:function(hex){
        var out;
        if(hex.length % 2  == 1)
            out='0'+hex;
        else
            out=hex;
        return out;        
    },

    getPhoneNineNumber:function(phone){
      var spit=phone.split('-');
      var ret;
      if (spit.length>0){
        var tmp=spit[spit.length-1];
        if(tmp.length>=9){
          ret = tmp.substr(tmp.length-9,9);
        }else if(tmp.length < 5){
          ret = '123456789';
        }else{
          ret=tmp;
        }
      }else{
        ret='123456789';
      }

      return ret;
    },
  },
  beforeDestroy() {    //页面关闭时清除定时器  
    clearInterval(this.clearTimeSet);
  },
}
</script>
<style scoped>
.home{
  height: 100%;
}
.buts{
  border-radius: 10px;
  margin-left: -20px;
}
.qrcode{
  display: flex;
  justify-content: center;
  justify-items: center;
  margin-top: 15%;
  margin-bottom: 120px;
}


.buts{
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
  position:fixed; bottom:0px;left: 48%; 
}
.buts img{
  width: 100%;
  height: 100%;
  position: relative;
}
.buts span{
  position: absolute;
  top: 45px;
  left:8px;
  color: #000;
}
</style>
